import { GraphQLClient } from "graphql-request";
import { lazyInit } from "../../utils/lazyInit.js";
import * as api from "../generated/api.sdk.js";
export const apiGraphqlClient = lazyInit(async () => new GraphQLClient(window.__APP_CONFIG.apiUrls.bramble));
export const getApiSdk = lazyInit(() => apiGraphqlClient().then(api.getSdk));
//# sourceMappingURL=api.js.map